import React from "react";
import { ContactDetailsType } from ".";
import { OptionsType } from "../../../../commonTypes/universalTypes";
import { returnInputFieldLength } from "../../../../utils/commonFunctions";
import Select from "react-select";

type AppProps = {
  contactDetails: ContactDetailsType;
  handleContactDetailsChange: (e: any) => void;
  handleStateChange: (data: OptionsType) => void;
  addressState?: any;
  countrySelectedList: any;
  onMenuClose: () => void;
  Option: any;
  countryFetching: boolean;
  finalCountry: any;
  handleChangeCountry: (data: any) => void;
  setLoadCondition: React.Dispatch<React.SetStateAction<boolean>>;
  setText: React.Dispatch<React.SetStateAction<string>>;
  setOffset: React.Dispatch<React.SetStateAction<number>>;
  limit: number;
  handleChangeState: (data: any) => void;
  finalStateList: any;
  stateFetching: boolean;
  handleChangeCity: (data: any) => void;
  finalCityList: any;
  selectedCityList: any;
  setCityOffset: React.Dispatch<React.SetStateAction<number>>;
  setStateOffset: React.Dispatch<React.SetStateAction<number>>;
  setCityText: React.Dispatch<React.SetStateAction<string>>;
  setStateText: React.Dispatch<React.SetStateAction<string>>;
  addressStateError?: string;
  countryError?: string;
  cityError?: string;
  isState: null | boolean;
  isCity: null | boolean;

};

const CustomerSupplierContactDetails = ({
  contactDetails,
  handleContactDetailsChange,
  addressState,
  handleStateChange,
  countrySelectedList,
  onMenuClose,
  Option,
  countryFetching,
  finalCountry,
  handleChangeCountry,
  setLoadCondition,
  setText,
  setOffset,
  limit,
  handleChangeState,
  finalStateList,
  stateFetching,
  handleChangeCity,
  finalCityList,
  selectedCityList,
  setStateOffset,
  setCityOffset,
  setStateText,
  setCityText,
  addressStateError,
  countryError,
  cityError,
  isState,
  isCity
}: AppProps) => {
  const {
    city,
    pin,
    country,
    mobile,
    addressOne,
    addressTwo,
    telephone,
    email,
    website,
  } = contactDetails;
  const checkBottom = (e: any) => {
    setLoadCondition(false);
    setOffset((prv: any) => prv + limit);
  };
  const checkBottomState = (e: any) => {
    setLoadCondition(false);
    setStateOffset((prv: any) => prv + limit);
  };
  const checkBottomCity = (e: any) => {
    setLoadCondition(false);
    setCityOffset((prv: any) => prv + limit);
  };
  return (
    <>
      {/* Third Row */}
      <div className="row">
        <div className="col-md-8">
          <form>
            <div className="form-group mt-2">
              <div>
                <label htmlFor="Address" className={addressOne ? "active" : ""}>
                  Address 1
                </label>
                <textarea
                  className={`form-control`}
                  name="addressOne"
                  value={addressOne}
                  onChange={(e) => handleContactDetailsChange(e)}
                  rows={2}
                  maxLength={100}
                />
              </div>
              <span className="input-length">
                {returnInputFieldLength(addressOne?.length, 100)}
              </span>
            </div>
          </form>
        </div>

        {/* mobile */}
        <div className="col-md-4">
          <form>
            <div className="form-group mt-2">
              <div>
                <label htmlFor="Mobile" className={mobile ? "active" : ""}>
                  Mobile Number
                </label>
                <input
                  type="number"
                  className={`form-control`}
                  name="mobile"
                  value={mobile}
                  onChange={(e) => handleContactDetailsChange(e)}
                  onWheel={(event) => event.currentTarget.blur()}
                />
              </div>
            </div>
          </form>
        </div>
      </div>

      <div className="row">
        <div className="col-md-8">
          <form>
            <div className="form-group mt-2">
              <div>
                <label htmlFor="Address" className={addressTwo ? "active" : ""}>
                  Address 2
                </label>
                <textarea
                  className={`form-control`}
                  name="addressTwo"
                  value={addressTwo}
                  onChange={(e) => handleContactDetailsChange(e)}
                  rows={2}
                  maxLength={100}
                />
              </div>
              <span className="input-length">
                {returnInputFieldLength(addressTwo?.length, 100)}
              </span>
            </div>
          </form>
        </div>
        <div className="col-md-4">
          <form>
            <div className="form-group mt-2">
              <div>
                <label htmlFor="Pin Code" className={pin ? "active" : ""}>
                  Pin Code
                </label>
                <input
                  type="number"
                  className={`form-control`}
                  name="pin"
                  value={pin}
                  onChange={(e) => handleContactDetailsChange(e)}
                  onWheel={(event) => event.currentTarget.blur()}
                />
              </div>
            </div>
          </form>
        </div>
      </div>

      {/* Fourth Row */}
      <div className="row">
        <div className="col-md-4">
          <form>
            <div className="form-group">
              <div>
                <label htmlFor="Country" className={country ? "active" : ""}>
                  Country <span className="color-red">*</span>
                </label>
                <Select
                  onMenuClose={onMenuClose}
                  components={{ Option }}
                  isSearchable={true}
                  options={countrySelectedList}
                  isLoading={countryFetching}
                  value={finalCountry}
                  onMenuScrollToBottom={(e: any) => checkBottom(e)}
                  onChange={(e) => {
                    handleChangeCountry(e);
                    handleChangeState(null);
                    handleChangeCity(null);
                  }}
                  onInputChange={(e) => {
                    setLoadCondition(false);
                    setText(e);
                    setOffset(0);
                  }}
                />
              </div>
              <small className="text-danger">{countryError}</small>
            </div>
          </form>
        </div>

        {finalCountry?.value && isState && (
          <div className="col-md-4">
            <form>
              <div className="form-group">
                <div>
                  {isState && (
                    <label
                      htmlFor="State"
                      className={addressState ? "active" : ""}
                    >
                      State <span className="color-red">*</span>
                    </label>
                  )}
                  {isState && (
                    <Select
                      onMenuClose={onMenuClose}
                      components={{ Option }}
                      isSearchable={true}
                      options={finalStateList}
                      placeholder="Choose City"
                      isLoading={stateFetching}
                      value={
                        addressState?.value
                          ? addressState
                          : { label: "Select..", value: null }
                      }
                      onMenuScrollToBottom={(e: any) => checkBottomState(e)}
                      onChange={(e) => {
                        handleChangeState(e);
                        handleChangeCity(null);
                      }}
                      onInputChange={(e) => {
                        setLoadCondition(false);
                        setStateText(e);
                        setStateOffset(0);
                      }}
                    />
                  )}
                  <small className="text-danger">{addressStateError}</small>
                </div>
              </div>
            </form>
          </div>
        )}

        {/*  city */}

        {/* {finalCityList && finalCityList.length > 0 && ( */}
        {((isState === true && addressState?.value && isCity) ||
          (isState === false && finalCountry?.value && isCity)) && (
          <div className="col-md-4">
            <form>
              <div className="form-group">
                <div>
                  <label htmlFor="City" className={city ? "active" : ""}>
                    City <span className="color-red">*</span>
                  </label>

                  <Select
                    onMenuClose={onMenuClose}
                    components={{ Option }}
                    isSearchable={true}
                    options={finalCityList}
                    isLoading={countryFetching}
                    value={
                      selectedCityList?.value
                        ? selectedCityList
                        : { label: "Select..", value: null }
                    }
                    onMenuScrollToBottom={(e: any) => checkBottomCity(e)}
                    onChange={(e) => handleChangeCity(e)}
                    onInputChange={(e) => {
                      setLoadCondition(false);
                      setCityText(e);
                      setCityOffset(0);
                    }}
                  />
                </div>
                <small className="text-danger">{cityError}</small>
              </div>
            </form>
          </div>
        )}
      </div>
      {/* Fifth Row */}
      <div className="row">
        <div className="col-md-4">
          <form>
            <div className="form-group">
              <div>
                <label
                  htmlFor="Telephone"
                  className={telephone ? "active" : ""}
                >
                  Telephone Number
                </label>
                <input
                  type="text"
                  className={`form-control`}
                  name="telephone"
                  value={telephone}
                  onChange={(e) => handleContactDetailsChange(e)}
                  onWheel={(event) => event.currentTarget.blur()}
                />
              </div>
            </div>
          </form>
        </div>
        <div className="col-md-4">
          <form>
            <div className="form-group">
              <div>
                <label htmlFor="Email" className={email ? "active" : ""}>
                  Email
                </label>
                <input
                  type="email"
                  className={`form-control`}
                  name="email"
                  value={email}
                  onChange={(e) => handleContactDetailsChange(e)}
                />
              </div>
            </div>
          </form>
        </div>
        <div className="col-md-4">
          <form>
            <div className="form-group">
              <div>
                <label htmlFor="Website">Website</label>
                <input
                  type="text"
                  className={`form-control`}
                  name="website"
                  value={website}
                  onChange={(e) => handleContactDetailsChange(e)}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default CustomerSupplierContactDetails;
